import { ActionTree } from 'vuex';
import { Store } from '@/store/types';
import { GetProjectsByBaseProjectNumberQuery, Project, ProjectSearchState } from '../types';
import { getProjectsByBaseProjectNumber } from '../service';

export const projectSearchActions: ActionTree<ProjectSearchState, Store> = {

  getProjectsByBaseProjectNumber({ commit, rootState }, query: GetProjectsByBaseProjectNumberQuery): Promise<void> {
    commit('updateLastSearchTerm', query.baseProjectNumber);
    commit('getProjectsByBaseProjectNumberStarted');
    return getProjectsByBaseProjectNumber(query)
      .then((projects: Project[]) => commit('getProjectsByBaseProjectNumberSucceeded', projects))
      .catch((error) => {
        commit('getProjectsByBaseProjectNumberFailed');
        return Promise.reject(error);
      });
  },

};
